import { inArray } from '../../../services/arrays';

function extractFromURL(name, url?): string | null {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    try {
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}

export function getUrlParam(name: string, force?: boolean): string {
    if (!force && inArray(name, ['id', 'session'])) {
        console.warn(`getUrlParam('${name}') is deprecated`);
    }

    let result = extractFromURL(name) || '';
    if (result === 'false') result = '';
    return result;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/url-params.ts